<template>
  <div class="index">
    <div class="index-con">
      <div class="login-con">
        <div class="index-title">Conference registration</div>
        <div class="steps">
          <el-steps align-center :active="active" finish-status="success">
            <el-step title="Registration form"></el-step>
            <el-step title="Payment"></el-step>
            <el-step title="Terms of payment"></el-step>
          </el-steps>
        </div>
        <div class="two-con">
          <div class="reg-type-title two-title">Register information</div>
          <div class="two-cons">
            <div class="two-lists">
              <div class="two-list">
                <p>
                  <b>Event</b>
                </p>
                <p>IDS 2024</p>
              </div>
              <div class="two-list">
                <p>
                  <b>First Name</b>
                </p>
                <p>{{ con.Firstname }}</p>
              </div>
              <div class="two-list">
                <p>
                  <b>Middle name</b>
                </p>
                <p>{{ con.Middlename }}</p>
              </div>
              <div class="two-list">
                <p>
                  <b>Last Name</b>
                </p>
                <p>{{ con.Lastname }}</p>
              </div>

              <div class="two-list">
                <p>
                  <b>Email</b>
                </p>
                <p>{{ con.email }}</p>
              </div>

              <div class="two-list">
                <p>
                  <b>Attendee's Name</b>
                </p>
                <p>{{ con.Attendeename }}</p>
              </div>
              <div class="two-list">
                <p>
                  <b>Bill to</b>
                </p>
                <p>{{ con.Billto }}</p>
              </div>
              <div class="two-list">
                <p>
                  <b>Any Remarks</b>
                </p>
                <p>{{ con.Remarks }}</p>
              </div>
              <div class="two-list">
                <p>
                  <b>Comments</b>
                </p>
                <p>{{ con.Comments }}</p>
              </div>
            </div>
            <div class="two-fee-lists">
              <div class="two-fee-list">
                <p>
                  <b>Event</b>
                </p>
                <p>
                  <b>Quantity</b>
                </p>
                <p>
                  <b>USD</b>
                </p>
                <p>
                  <b>CNY</b>
                </p>
              </div>
              <div class="two-fee-list">
                <p>Delegate</p>
                <p>{{ con.Delegate_num }}</p>
                <p>{{ con.Delegate_num * 500 }} USD </p>
                <p></p>
              </div>
              <div class="two-fee-list">
                <p>Delegate (Early bird)</p>
                <p>{{ con.Early_bird_num }}</p>
                <p>{{ con.Early_bird_num * 450 }} USD </p>
                <p></p>
              </div>
              <div class="two-fee-list">
                <p>Student </p>
                <p> {{ con.Student_num }}</p>
                <p>{{ con.Student_num * 250 }} USD</p>
                <p></p>
              </div>
              <div class="two-fee-list">
                <p>Accompanying person:</p>
                <p>{{ con.Accompanying_num }}</p>
                <p>{{ con.Accompanying_num * 150 }} USD</p>
                <p></p>
              </div>
              <div class="two-fee-list">
                <p>Banquet & Cultural activity</p>
                <p>{{ con.Banquet_num }}</p>
                <p>{{ con.Banquet_num * 50 }} USD</p>
                <p></p>
              </div>
              <div class="two-fee-list bg-red">
                <p>Total</p>
                <p>{{ con.Early_bird_num + con.Delegate_num + con.Student_num + con.Accompanying_num + con.Banquet_num
                  }}
                </p>
                <p>{{
                  con.Early_bird_total +
                  con.Delegate_total +
                  con.Student_total +
                  con.Accompanying_total +
                  con.Banquet_total }} USD</p>
                <p class="mintext">

                </p>
              </div>
            </div>
            <div class="two-phone-blue-tip">
              For non-USD currencies, please use the exchange rate on the date of payment.
            </div>


            <div class="bank-con">
              <div class="bank-title">
                Payment voucher screenshot:
              </div>
              <div class="bank-cons">
                <p class="bank-text">
                  <a v-for="(itm, ind) in Payment_photo" :key='ind' :href="'https://www.ids2024.com/public/' + itm"
                    target="_blank">
                    <img :src="'https://www.ids2024.com/public/' + itm">
                  </a>
                </p>
              </div>
            </div>

            <div class="two-phone">

              <div class="two-phone-btns">

                <div class="two-phone-btn" @click="subFn">
                  <i class="el-icon-success"></i> Confirm, back
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      active: 2,
      Payment_photo: '',
      con: {
        Firstname: '',
        Lastname: '',
        Middlename: '',
        Attendeename: '',
        Delegate_num: '',
        Early_bird_num: '',
        Student_num: '',
        Accompanying_num: '',
        Banquet_num: '',
        Billto: '',
        Remarks: '',
        Comments: '',
        email: ''
      }
    };
  },
  mounted() {
    this.email = localStorage.getItem("email");
    this.visitor_id = localStorage.getItem("visitor_id");
    this.getInfo();
  },
  methods: {
    subFn() {
      this.$router.push('/loginThen')
    },
    getInfo() {
      this.$http.get_info({
        visitor_id: this.visitor_id,
        email: this.email
      }).then(res => {
        let con = res.data.data[0];
        this.Payment_photo = con.Payment_photo.split(',')// "https://www.ids2024.com/public/" + con.Payment_photo
        con.Delegate_num = Number(con.Delegate_num)
        con.Early_bird_num = Number(con.Early_bird_num)
        con.Student_num = Number(con.Student_num)
        con.Accompanying_num = Number(con.Accompanying_num)
        con.Banquet_num = Number(con.Banquet_num)

        con.Early_bird_total = Number(con.Early_bird_total)
        con.Delegate_total = Number(con.Delegate_total)
        con.Student_total = Number(con.Student_total)
        con.Accompanying_total = Number(con.Accompanying_total)
        con.Banquet_total = Number(con.Banquet_total)
        con.Firstname = con.Firstname ? con.Firstname : "";
        con.Lastname = con.Lastname ? con.Lastname : "";
        con.Middlename = con.Middlename ? con.Middlename : "";
        con.Attendeename = con.Attendeename ? con.Attendeename : "";
        con.Billto = con.Billto ? con.Billto : "";
        con.Remarks = con.Remarks ? con.Remarks : "";
        con.Comments = con.Comments ? con.Comments : "";
        this.con = con
        console.log('sss=' + con.Payment_photo)
      })
    },
    backFn() {
      this.$router.push('/register1')
    },
    jian(index) {
      console.log(index)
      if (index == 1) {
        this.num1--;
        if (this.num1 <= 0) {
          this.num1 = 0;
        }
      }
      if (index == 2) {
        this.num2--;
        if (this.num2 <= 0) {
          this.num2 = 0;
        }
      }
      if (index == 3) {
        this.num3--;
        if (this.num3 <= 0) {
          this.num3 = 0;
        }
      }
      if (index == 4) {
        this.num4--;
        if (this.num4 <= 0) {
          this.num4 = 0;
        }
      }
      if (index == 5) {
        this.num5--;
        if (this.num5 <= 0) {
          this.num5 = 0;
        }
      }
    },
    jia(index) {
      if (index == 1) {
        this.num1++;
      }
      if (index == 2) {
        this.num2++;
      }
      if (index == 3) {
        this.num3++;
      }
      if (index == 4) {
        this.num4++;
      }
      if (index == 5) {
        this.num5++;
      }
    },
    toBank() {
      this.$router.push("/bank");
    },
    next() {
      if (this.active++ > 2) this.active = 0;
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handlePreview(file) {
      console.log(file);
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length
        } 个文件`
      );
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },
  },
};
</script>
<style scoped>
.bank-con {
  border: 1px solid #357ebd;
  border-radius: 4px;
  margin-bottom: 20px;
}

.bank-title {
  background: #357ebd;
  color: #fff;
  padding: 15px;
}

.bank-text {
  margin: 30px 0;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}

.bank-text a {
  display: inline-block;
  width: 200px;
  height: 200px;
  overflow: hidden;
  margin: 6px;
  flex-shrink: 0;
}

.bank-text img {
  width: 100%;
  height: auto;
}

.steps {
  padding: 30px;
  box-sizing: border-box;
}

.index-con {
  width: 1200px;
  margin: 0 auto;
}

.login-con {
  margin-top: 20px;
}

.index-title {
  font-size: 18px;
  font-weight: 500;
  height: 60px;
  line-height: 60px;
  padding-left: 20px;
  box-sizing: border-box;
  background: #f5f5f5;
  border-bottom: 1px solid #ddd;
}

.login-con {
  border: 1px solid #ddd;
  border-radius: 4px;
  margin-bottom: 30px;
}

.login-cons {
  padding: 90px 20px 20px;
  box-sizing: border-box;
}

.df {
  display: flex;
  align-items: center;
}

.df .login-title {
  margin-right: 20px;
}

.login-center {
  width: 100%;
  display: flex;
  margin: 0 auto;
  flex-wrap: wrap;
}

.login-title {
  font-weight: 600;
  margin-bottom: 10px;
}

.login-list {
  margin-bottom: 20px;
  width: calc(33% - 20px);
  margin-top: 20px;
}

.login-list:nth-of-type(3n-1) {
  margin: 20px 20px 0;
}

.login-list input {
  width: 100%;
  padding-left: 10px;
  box-sizing: border-box;
  color: #555;
  height: 42px;
  border-radius: 4px;
  border: 1px solid #ccc;
}

.login-btn {
  color: #fff;
  background-color: #428bca;
  border: 1px solid #357ebd;
  border-radius: 4px;
  padding: 6px 12px;
  cursor: pointer;
  font-size: 16px;
  margin-bottom: 15px;
  display: inline-block;
}

.login-text {
  margin-bottom: 15px;
}

.text-blue {
  color: #428bca;
  cursor: pointer;
}

.reg-type {
  padding: 20px;
  box-sizing: border-box;
}

.reg-type>div {
  border: 1px solid #ccc;
  border-radius: 4px;
}

.reg-type-title {
  height: 50px;
  line-height: 50px;
  border-bottom: 1px solid #ccc;
  text-indent: 20px;
  background: #d9edf7;
}

.reg-type-lists {
  display: flex;
  flex-wrap: wrap;
}

.reg-type-list {
  width: 50%;
  align-items: center;
  padding: 10px 20px;
  box-sizing: border-box;
  display: flex;
  padding-right: 60px;
  justify-content: space-between;
}

.reg-type-nums {
  display: flex;
}

.reg-type-jian,
.reg-type-jia {
  width: 30px;
  text-align: center;
  height: 30px;
  line-height: 30px;
  border: 1px solid #ccc;
  margin: 0 6px;
  border-radius: 4px;
  cursor: pointer;
  background: #eee;
}

.reg-type-num {
  width: 40px;
  text-align: center;
  border: 1px solid #ccc;
  border-radius: 4px;
}


.p-20 {
  padding: 20px;
  box-sizing: border-box;
}

.add-pay-btn {
  color: #fff;
  background-color: #5bc0de;
  border-color: #46b8da;
  width: auto;
  display: inline-block;
  margin: 20px 0;
  padding: 10px 20px;
  border-radius: 4px;
  cursor: pointer;
}

.tip {
  padding: 15px;
  margin-bottom: 20px;
  border: 1px solid transparent;
  border-radius: 4px;
  color: #8a6d3b;
  background-color: #fcf8e3;
  border-color: #faebcc;
}

.pay-contents {
  border: 1px solid #ccc;
  border-radius: 4px;
}

.pay-title {
  background: #fcf8e3;
}

.pay-con {
  padding: 20px;
  box-sizing: border-box;
  display: flex;
}

.pay-list>input {
  height: 40px;
  padding-left: 10px;
  width: 100%;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  box-sizing: border-box;
}

.flex-1 {
  flex: 1;
}

.pay-list>p {
  margin-bottom: 4px;
}

.m-20 {
  margin: 0 20px;
}

.offical-cons {
  margin-bottom: 20px;
  margin-top: 20px;
  border: 1px solid #ccc;
  border-radius: 4px;
}

.offical-title {
  background: #eee;
}

.offical-lists {
  padding: 20px;
  box-sizing: border-box;
}

.offical-list {
  margin-bottom: 20px;
}

.offical-list p {
  margin-bottom: 4px;
}

.offical-list input {
  height: 40px;
  width: 100%;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  box-sizing: border-box;
}

.offical-list-select {
  width: 100%;
  margin-bottom: 10px;
}

.textarea {
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  width: 100%;
}

.sub-mit {
  width: auto;
  display: inline-block;
  padding: 10px 46px;
  cursor: pointer;
  font-size: 18px;
  line-height: 1.33;
  border-radius: 6px;
  color: #fff;
  background-color: #5cb85c;
}

.reg-type-title {
  background: #eee;
}

.two-con {
  border-radius: 4px;
  width: 1000px;
  margin: 10px auto;
  border: 1px solid #ccc;
}

.two-cons {
  padding: 20px;
  box-sizing: border-box;
}

.two-lists {
  border: 1px solid #ccc;
  border-radius: 4px;
}

.two-list,
.two-fee-list {
  display: flex;
  height: 35px;
  align-items: center;
  text-indent: 15px;
  line-height: 35px;
  border-bottom: 1px solid #ccc;
}

.three-fee-list {
  display: flex;
  height: 75px;
  align-items: center;
  text-indent: 15px;
  line-height: 35px;
  border-bottom: 1px solid #ccc;
}

.bg-green {
  background: #dff0d8;
}

.bg-blue {
  background: #d9edf7;
}

.two-list p:nth-of-type(1) {
  border-right: 1px solid #ccc;
  width: 35%;
  height: 35px;
}

.two-list p:nth-of-type(2) {
  flex: 1;
  height: 35px;
}

.two-list:nth-of-type(2n) {
  background: #eee;
}

.two-fee-lists {
  margin-top: 20px;
  border: 1px solid #ccc;
  border-radius: 4px;
  background: #fcf8e3;
}

.two-fee-list:nth-of-type(1) {
  background: #fff;
}

.two-fee-list p {
  width: 25%;
  border-right: 1px solid #ccc;
}

.two-fee-list p:nth-last-of-type(1) {
  border-right: 0;
}

.two-lists .two-list:nth-last-of-type(1),
.two-fee-lists .two-fee-list:nth-last-of-type(1) {
  border-bottom: 0;
}

.bg-red {
  background: #f2dede;
  color: #f53f3f;
  font-size: 26px;
  height: 60px;
  font-weight: 600;
}

.two-fee-list.bg-red p {
  height: 60px;
  line-height: 60px;
}

.two-phone-blue-tip {
  color: #31708f;
  border: 1px solid transparent;
  background-color: #d9edf7;
  border-color: #bce8f1;
  padding: 15px;
  margin-bottom: 20px;
  border-radius: 4px;
  margin-top: 10px;
}

.two-phone-title {
  margin-top: 20px;
  margin-bottom: 10px;
}

.two-phone-btns {
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 40px;
}

.two-phone-btn {
  border: 1px solid transparent;
  color: #fff;
  background-color: #5bc0de;
  border-color: #46b8da;
  padding: 10px 16px;
  font-size: 18px;
  line-height: 1.33;
  border-radius: 6px;
  cursor: pointer;
  margin: 0 15px;
}

.two-phone-btn:nth-of-type(2) {
  background-color: #5cb85c;
  border-color: #4cae4c;
}

.three-con {
  width: 1000px;
  margin: 0 auto 40px;
  border: 1px solid #ccc;
  border-radius: 4px;
}

.three-cons {
  padding: 20px;
  box-sizing: border-box;
}

.three-tip {
  background: #dff0d8;
  padding: 10px;
  border-radius: 4px;
  margin-bottom: 20px;
}

.bank-img {
  width: 350px;
  height: auto;
  broder: 4px solid #bce8f1;
  border-radius: 4px;
  cursor: pointer;
}

@media screen and (max-width: 768px) {
  .index-con {
    width: 100%;
  }

  .mintext {
    font-size: 7px;
  }

  .login-tip {
    font-size: 14px;
    text-indent: 10px;
  }

  .login-list input {
    width: 100%;
  }

  .info-small-title {
    height: auto;
  }

  .login-center {
    width: 100%;
  }

  .login-list {
    width: 100%;
  }

  .login-list:nth-of-type(3n-1) {
    margin: 20px 0;
  }

  .reg-type-list {
    width: 100%;
    padding-right: 10px;
  }

  .pay-con {
    flex-wrap: wrap;
  }

  .pay-list {
    width: 100%;
  }

  .pay-list:nth-of-type(2) {
    margin: 20px 0;
  }

  .two-con {
    width: 100%;
  }

  .two-list,
  .two-fee-list {
    min-height: 45px;
    line-height: 1.9;
    display: flex;
    align-items: center;
    justify-content: center;
    height: auto;
  }

  .two-list p,
  .two-fee-list p {
    height: 100%;
    min-height: 45px;
    display: flex;
    align-items: center;
  }

  .two-list p:nth-of-type(1) {
    width: 50%;
  }

  .two-phone-btns {
    display: block;
  }

  .two-phone-btn {
    margin: 20px 0;
  }

  .three-con {
    width: 100%;
  }

  .reg-type-title {
    height: auto;
    line-height: 1.4;
    padding: 20px 15px;
    text-indent: 0;
    box-sizing: border-box;
  }

  .bank-img {
    width: 100%;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/registerView.vue